import React from 'react';
import styled from 'styled-components';
import { ReactComponent as Audio } from 'assets/files/audio.svg';
import { ReactComponent as Video } from 'assets/files/video.svg';
import { ReactComponent as Word } from 'assets/files/word.svg';
import { ReactComponent as Html } from 'assets/files/html.svg';
import Doc from 'assets/files/doc.png';
import Jpg from 'assets/files/jpg.png';
import Pdf from 'assets/files/pdf.png';
import Png from 'assets/files/png.png';
import Ppt from 'assets/files/ppt.png';
import Svg from 'assets/files/svg.png';
import Txt from 'assets/files/txt.png';
import Xls from 'assets/files/xls.png';
import Xml from 'assets/files/xml.png';
import Zip from 'assets/files/zip.png';
import Rar from 'assets/files/rar.png';
import Access from 'assets/files/access.png';
import Undefined from 'assets/files/undefined.png';
import mime from 'mime-types';

const Img = styled.img`
  height: 64px;
  width: auto;
  border-radius: 5px;
  margin-bottom: 5px;
`;

export const getFileIcon = (type) => {
  const extension = mime.extension(type);
  switch (extension) {
    case 'jpg':
    case 'jpeg':
      return <Img src={Jpg} alt="Ikona" />;
    case 'pdf':
      return <Img src={Pdf} alt="Ikona" />;
    case 'doc':
    case 'docx':
      return <Img src={Doc} alt="Ikona" />;
    case 'xls':
    case 'xlsx':
      return <Img src={Xls} alt="Ikona" />;
    case 'ppt':
    case 'pptx':
      return <Img src={Ppt} alt="Ikona" />;
    case 'xml':
      return <Img src={Xml} alt="Ikona" />;
    case 'png':
      return <Img src={Png} alt="Ikona" />;
    case 'gif':
    case 'bmp':
    case 'tiff':
    case 'svg':
      return <Img src={Svg} alt="Ikona" />;
    case 'aac':
    case 'midi':
    case 'x-midi':
    case 'mpeg':
    case 'ogg':
    case 'opus':
    case 'wav':
    case 'webm':
    case '3gpp':
    case '3gpp2':
      return <Audio />;

    case 'zip':
      return <Img src={Zip} alt="Ikona" />;

    case 'rar':
      return <Img src={Rar} alt="Ikona" />;

    default:
      break;
  }

  switch (type) {
    case 'audio/aac':
    case 'audio/midi':
    case 'audio/x-midi':
    case 'audio/mpeg':
    case 'audio/ogg':
    case 'audio/opus':
    case 'audio/wav':
    case 'audio/webm':
    case 'audio/3gpp':
    case 'audio/3gpp2':
      return <Audio />;

    case 'video/x-msvideo':
    case 'video/mpeg':
    case 'video/ogg':
    case 'video/mp2t':
    case 'video/webm':
    case 'video/3gpp':
    case 'video/3gpp2':
      return <Video />;

    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'text/rtf':
      return <Word />;

    case 'text/plain':
      return <Img src={Txt} alt="Ikona" />;

    case 'text/html':
      return <Html />;

    case 'application/vnd.rar':
    case 'application/octet-stream':
    case 'application/zip':
    case 'application/x-zip-compressed':
    case 'application/x-7z-compressed':
      return <Img src={Rar} alt="Ikona" />;

    case 'application/msaccess':
      return <Img src={Access} alt="Ikona" />;

    default:
      return <Img src={Undefined} alt="Ikona" />;
  }
};

export const getSizeLabel = (size) => {
  let newSize = size;
  let label = 'B';

  if (newSize >= 1024) {
    newSize /= 1024;
    label = 'KB';
    if (newSize >= 1024) {
      newSize /= 1024;
      label = 'MB';
    }
  }

  newSize = newSize.toFixed();

  return `${newSize}${label}`;
};

const monthsInYear = [
  'stycznia',
  'lutego',
  'marca',
  'kwietnia',
  'maja',
  'czerwca',
  'lipca',
  'sierpnia',
  'września',
  'października',
  'listopada',
  'grudnia',
];

const today = new Date();
const currentDay = today.getDate();
const currentMonth = today.getMonth();

let yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);
const yesterdayMonth = yesterday.getMonth();
yesterday = yesterday.getDate();

export const getDateFromTs = (ts) => {
  const date = new Date(ts);
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  const hour = date.getHours();
  let minute = date.getMinutes();
  minute = minute < 10 ? `0${minute}` : minute;

  let dateSyntax;

  if (currentDay === day && currentMonth === month) {
    dateSyntax = `Dzisiaj ${hour}:${minute}`;
  } else if (yesterday === day && yesterdayMonth === month) {
    dateSyntax = `Wczoraj ${hour}:${minute}`;
  } else {
    dateSyntax = `${day} ${monthsInYear[month]} ${year} ${hour}:${minute}`;
  }

  return dateSyntax;
};

export const getDateFromTsShort = (ts) => {
  const date = new Date(ts);
  let day = date.getDate();
  let month = date.getMonth();
  const year = date.getFullYear();
  day = day < 10 ? `0${day}` : day;
  month = month < 10 ? `0${month}` : month;

  return `${day}.${parseFloat(month) + 1}.${year}`;
};
